var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mod"},[_c('img',{staticClass:"item",attrs:{"src":require("@/assets/mini_code.jpg")}}),_c('span',{staticClass:"desc",attrs:{"lines":undefined}},[_vm._v(" 关注齐装云管家小程序， "),_c('br'),_vm._v("随时随地掌握订单动态！ ")])])}
var staticRenderFns = []

export { render, staticRenderFns }